<markant-tab-bar class="nav-bar" [activeTab]="activeIndex">
  @for (route of routes; track $index) {
    @if (route.external) {
      <a [href]="route.route" target="_blank">
        <markant-tab
          [attr.id]="'header-navigation-tab-' + route.key"
          [attr.data-cy]="'header-navigation-tab-' + route.key"
          [indicatorContentWidth]="false"
          [label]="route.label | transloco"
        ></markant-tab>
      </a>
    } @else if (route.route) {
      <markant-tab
        [attr.id]="'header-navigation-tab-' + route.key"
        [attr.data-cy]="'header-navigation-tab-' + route.key"
        [indicatorContentWidth]="false"
        [label]="route.label | transloco"
        [routerLink]="route.route"
      ></markant-tab>
    }
  }
  <markant-tab class="hidden-tab"></markant-tab>
</markant-tab-bar>
